import Tile from 'bee-tile'

export default Tile
